/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingLineItemTypeRegexQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("BillingLineItemTypeRegexQueryOperator");
    }

    getFixupPrototypeFunction() { return BillingLineItemTypeRegexQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<BillingLineItemTypeRegexQueryOperator>): BillingLineItemTypeRegexQueryOperator {
        let obj = Object.assign(new BillingLineItemTypeRegexQueryOperator(), model);
        BillingLineItemTypeRegexQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingLineItemTypeRegexQueryOperator>): BillingLineItemTypeRegexQueryOperator {
        if (!model) return null;
        return BillingLineItemTypeRegexQueryOperator.newInstance(<BillingLineItemTypeRegexQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingLineItemTypeRegexQueryOperator) {
        if (!obj) return;

        models.BillingLineItemTypeRegexQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingLineItemTypeRegexQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingLineItemTypeRegexQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.line_item_type) {
            models.Regex.fixupPrototype(this.line_item_type);
        }
    }

    /**
     * Include response that has the given line_item_type
     */
    line_item_type: models.Regex;

}
